import { BASE_API_URL } from '../../config';
import { ApiResponse, del, get, patch, post } from '../base';
import {
  CreatePlanogramRequest,
  PlanogramResponse,
  PlanogramsResponse,
  UpdatePlanogramRequest,
} from './reqres';

export default function PlanogramService() {
  return Object.freeze({
    listPlanograms(query?: string): Promise<PlanogramsResponse> {
      return get(
        `${BASE_API_URL()}/planogram${query}`
      ) as Promise<PlanogramsResponse>;
    },
    getPlanogram(planogramId: string): Promise<ApiResponse> {
      return get(
        `${BASE_API_URL()}/planogram/${planogramId}`
      ) as Promise<ApiResponse>;
    },
    async createPlanogram(
      req: CreatePlanogramRequest
    ): Promise<PlanogramResponse> {
      const response = await post(`${BASE_API_URL()}/planogram`, req);
      return response.data as PlanogramResponse;
    },
    async updatePlanogram(
      planogramId: string,
      req: UpdatePlanogramRequest,
      query = ''
    ): Promise<PlanogramResponse> {
      const response = await patch(
        `${BASE_API_URL()}/planogram/${planogramId}${query}`,
        req
      );
      return response.data as PlanogramResponse;
    },
    async deletePlanogram(planogramId: string): Promise<ApiResponse> {
      const response = await del(`${BASE_API_URL()}/planogram/${planogramId}`);
      return response.data as ApiResponse;
    },
    async sendToOVR(planogramId: string): Promise<ApiResponse> {
      const response = await post(
        `${BASE_API_URL()}/planogram/${planogramId}/sendToAutomation`,
        {}
      );
      return response.data as ApiResponse;
    },
  });
}
